import { pathCombine } from './module';
import { IS_DEV_ENV, IS_TEST_ENV } from '../windowProps';
import { getAppRoot } from '../../navigation/routes';


export const BaseUrl = IS_DEV_ENV || IS_TEST_ENV
 ? 'https://staging.truscore.com/newportal/api/'
 : pathCombine(window.location.origin, getAppRoot(window), '/api/');
// : 'https://staging.truscore.com/newportal/api/'; // For testing prod builds on localhost
// : 'https://localhost:44371/'; // For testing entirely local


export const Endpoints = {
  Config:       pathCombine(BaseUrl, 'config/configSettings'),
  FeatureFlags: pathCombine(BaseUrl, 'config/featureFlags'),

  //I18n
  TranslatedLanguages: pathCombine(BaseUrl, 'language', 'translated'),
  PortalMessages:      pathCombine(BaseUrl, 'message', 'portal'),

  ProjectLanguages: pathCombine(BaseUrl, 'language', 'project'),
  ProjectMessages:  pathCombine(BaseUrl, 'message', 'project'),
  AllLanguages: pathCombine(BaseUrl, 'language', 'all'),

  //Login
  Authenticate:                      pathCombine(BaseUrl, 'user', 'authenticate'),
  AuthenticateBX:                    pathCombine(BaseUrl, 'user', 'authenticateBX'),
  AuthenticateTalentSmart:           pathCombine(BaseUrl, 'user', 'authenticateTalentSmart'),
  SecurityQuestionKeys:              pathCombine(BaseUrl, 'message', 'securityQuestionKeys'),
  GetSecurityQuestion:               pathCombine(BaseUrl, 'user', 'getsecurityquestion'),
  SendPortalForgotPassword:          pathCombine(BaseUrl, 'email', 'sendPortalForgotPassword'),
  SendRaterApprovalForgotPassword:   pathCombine(BaseUrl, 'email', 'sendRaterApprovalForgotPassword'),
  SendReportRecipientForgotPassword: pathCombine(BaseUrl, 'email', 'sendReportRecipientForgotPassword'),
  UpdateSecurityQuestion:            pathCombine(BaseUrl, 'user', 'updatesecurityquestion'),
  UpdatePassword:                    pathCombine(BaseUrl, 'user', 'updatePassword'),
  PasswordRequirements:              pathCombine(BaseUrl, 'message', 'passwordRequirements'),

  // Project
  Projects:                pathCombine(BaseUrl, 'project', 'portalProjects'),
  ProjectSummary:          pathCombine(BaseUrl, '/project/participantProject'),
  ParticipantRequirements: pathCombine(BaseUrl, '/participant/requirements'),
  ProjectResources:        pathCombine(BaseUrl, '/project/customResources'),
  ProjectId:               pathCombine(BaseUrl, '/project/projectId'),
  UpdateConfidentiality:   pathCombine(BaseUrl, '/participant/updateConfidentiality'),
  DevResources:            pathCombine(BaseUrl, '/project/developmentResources'),
  CurrentStatus:           pathCombine(BaseUrl, '/project/currentStatus'),
  ProjectCSContact:        pathCombine(BaseUrl, '/customerSupport/contactInfo'),
  GetEBookUrl:             pathCombine(BaseUrl, '/eBook/eBookUrl'),

  // Rater
  AddRaterByEmail:      pathCombine(BaseUrl, '/rater/addRaterByEmail'),
  AddRaterById:         pathCombine(BaseUrl, '/rater/addRaterById'),
  ParticipantRaters:    pathCombine(BaseUrl, '/rater/participantRaters'),
  PreviousRaters:       pathCombine(BaseUrl, '/rater/previousRaters'),
  DirectoryRaters:      pathCombine(BaseUrl, '/rater/directoryRaters'),
  UpdateInviteData:     pathCombine(BaseUrl, '/rater/updateInviteData'),
  InviteEmailPreview:   pathCombine(BaseUrl, '/email/inviteBodyPreview'),
  ApproverEmailPreview: pathCombine(BaseUrl, '/email/approverBodyPreview'),
  SendInvitations:      pathCombine(BaseUrl, '/email/sendInvitations'),
  SendReminders:        pathCombine(BaseUrl, '/email/sendReminders'),
  RaterLevels:          pathCombine(BaseUrl, '/rater/raterLevels'),
  DeleteRater:          pathCombine(BaseUrl, '/rater/deleteRater'),
  EditRater:            pathCombine(BaseUrl, '/rater/updateRater'),
  SetApprover:          pathCombine(BaseUrl, '/rater/updateApprover'),
  SendForApproval:      pathCombine(BaseUrl, '/email/sendApprover'),
  UndeliveredEmails:    pathCombine(BaseUrl, '/rater/undeliveredEmails'),

  // Rater Approval
  RaterApprovalParticipants: pathCombine(BaseUrl, '/participant/raterApprovalParticipants'),
  RaterApprovalRaters:       pathCombine(BaseUrl, '/rater/raterApprovalRaters'),
  SendRaterApproval:         pathCombine(BaseUrl, '/email/sendApproval'),
  UpdateApprovalStatus:      pathCombine(BaseUrl, '/rater/updateApprovalStatus'),
  RaterApprovalEmailPreview: pathCombine(BaseUrl, '/email/approvalBodyPreview'),
  AddRaterByEmailAsApprover: pathCombine(BaseUrl, '/rater/addRaterByEmailAsApprover'),

  // Set Goals
  GoalsAnswers:  pathCombine(BaseUrl, '/setGoal/getGoals'),
  SetGoalAnswer: pathCombine(BaseUrl, '/setGoal/saveAnswer'),
  SendGoals:     pathCombine(BaseUrl, '/email/sendGoals'),

  //SSO
  YmcaLogin:     pathCombine(BaseUrl, '/ymca/login'),
  IsSso:         pathCombine(BaseUrl, '/sso/isSso'),
  SamlLogin:     pathCombine(BaseUrl, '/sso/login'),
  SamlAssertion: pathCombine(BaseUrl, '/sso/getUser'),

  // Create Survey
  GetSelectedQuestions:         pathCombine(BaseUrl, '/createSurvey/getSelectedQuestions'),
  AddQuestion:                  pathCombine(BaseUrl, '/createSurvey/addQuestion'),
  AddQuestionsForCompetency:    pathCombine(BaseUrl, '/createSurvey/addQuestionsForCompetency'),
  DeleteQuestion:               pathCombine(BaseUrl, '/createSurvey/deleteQuestion'),
  DeleteQuestionsForCompetency: pathCombine(BaseUrl, '/createSurvey/deleteQuestionsForCompetency'),
  GetCompetenciesAndQuestions:  pathCombine(BaseUrl, '/createSurvey/getCompetenciesAndQuestions'),
  ApplyPendingChanges:          pathCombine(BaseUrl, '/createSurvey/applyPendingChanges'),
  UnsetCreatedSurvey:           pathCombine(BaseUrl, '/createSurvey/unsetCreatedSurvey'),

  // Dev Plan
  GetDevPlanItems:                   pathCombine(BaseUrl, '/developmentPlan/items'),
  GetDevPlanActions:                 pathCombine(BaseUrl, '/developmentPlan/actions'),
  GetDevPlanFieldsAndAnswers:        pathCombine(BaseUrl, '/developmentPlan/fieldsAndAnswers'),
  AddDevPlanItem:                    pathCombine(BaseUrl, '/developmentPlan/addDevPlanItem'),
  AddDevPlanAction:                  pathCombine(BaseUrl, '/developmentPlan/addDevPlanAction'),
  DeleteDevPlanItem:                 pathCombine(BaseUrl, '/developmentPlan/deleteDevPlanItem'),
  DeleteDevPlanAction:               pathCombine(BaseUrl, '/developmentPlan/deleteDevPlanAction'),
  UpdateDevPlanItemDescription:      pathCombine(BaseUrl, '/developmentPlan/updateItemDescription'),
  UpdateDevPlanItemTitle:            pathCombine(BaseUrl, '/developmentPlan/updateItemTitle'),
  UpdateDevPlanActionCompleteByDate: pathCombine(BaseUrl, '/developmentPlan/updateActionCompleteBy'),
  UpdateDevPlanActionStatus:         pathCombine(BaseUrl, '/developmentPlan/updateActionStatus'),
  UpdateDevPlanFieldAnswer:          pathCombine(BaseUrl, '/developmentPlan/updateFieldAnswer'),
  GetStatusKeys:                     pathCombine(BaseUrl, '/developmentPlan/statusKeys'),
  SetRemindersOn:                    pathCombine(BaseUrl, '/developmentPlan/updateRemindersOn'),
  GetRemindersOn:                    pathCombine(BaseUrl, '/developmentPlan/getRemindersOn'),
  SendDevPlan:                       pathCombine(BaseUrl, '/email/sendDevPlan'),
  GetDevActionListItems:             pathCombine(BaseUrl, '/developmentPlan/getDevActionListItems'),
  UpdateFieldAnswerList:             pathCombine(BaseUrl, '/developmentPlan/updateFieldAnswerList'),

  // Dev Plan Collaboration
  AuthenticateCollaborator:           pathCombine(BaseUrl, '/collaboration/authenticateCollaborator'),
  DevPlanCollaborators:               pathCombine(BaseUrl, '/collaboration/collaborators'),
  AddDevPlanCollaborator:             pathCombine(BaseUrl, '/collaboration/addCollaborator'),
  SetDevPlanCollaboratorAccepted:     pathCombine(BaseUrl, '/collaboration/updateAccepted'),
  DeleteDevPlanCollaborator:          pathCombine(BaseUrl, '/collaboration/deleteCollaborator'),
  SendDevPlanCollaboratorInvite:      pathCombine(BaseUrl, '/email/sendCollaborationInvite'),
  SendDevItemCommentNotification:     pathCombine(BaseUrl, '/email/sendCollaboratorComment'),
  SendParticipantCommentNotification: pathCombine(BaseUrl, '/email/sendParticipantComment'),

  DevItemComments:        pathCombine(BaseUrl, '/collaboration/comments'),
  AddDevItemComment:      pathCombine(BaseUrl, '/collaboration/addComment'),
  UpdateDevItemComment:   pathCombine(BaseUrl, '/collaboration/updateComment'),
  SetDevItemCommentsRead: pathCombine(BaseUrl, '/collaboration/updateCommentAsRead'),
  DeleteDevItemComment:   pathCombine(BaseUrl, '/collaboration/deleteComment'),

  // View Reports
  ViewReports: pathCombine(BaseUrl, '/report/viewReportData'),
  ReportData:  pathCombine(BaseUrl, '/report/reportData'),

  GetEQScores:          pathCombine(BaseUrl, '/report/eqScores'),
  SendEQScores:         pathCombine(BaseUrl, '/email/sendEQScores'),
  EQScoresEmailPreview: pathCombine(BaseUrl, '/email/eqScoresEmailBodyPreview'),

  // Report Recipient
  ReportRecipientProjects:     pathCombine(BaseUrl, '/project/reportRecipientProjects'),
  ReportRecipientParticipants: pathCombine(BaseUrl, '/participant/reportRecipientParticipants'),
  ReportRecipientReports:      pathCombine(BaseUrl, '/report/reportRecipientReports'),
  DeliverReports:              pathCombine(BaseUrl, '/report/deliverReports'),

  // Trace Logging
  LogInfo: pathCombine(BaseUrl, '/traceLog/logInfo'),
};
